import { Box, Typography } from "@mui/material";
import useShareLeadWhatsapp from "@/modules/lead-page/hooks/lead-info/lead-actions/share-lead-whatsapp.hook";
import { nawyTheme } from "@/styles/nawy-theme/nawy-theme";

const ShareLeadWhatsapp = () => {
  const { handleLeadWhatsappShare } = useShareLeadWhatsapp();
  return (
    <>
      <Box
        sx={{
          display: "flex",
          gap: nawyTheme.nawy.spacing.xs,
          padding: nawyTheme.nawy.spacing.xs,
          alignItems: "center",
          width: "100%",
          height: "100%",
          cursor: "pointer",
          ":hover": {
            backgroundColor: nawyTheme.nawy.colors.semantic.layer.secondary,
          },
        }}
        onClick={handleLeadWhatsappShare}
      >
        <Typography
          sx={{
            color: nawyTheme.nawy.colors.semantic.text.primary,
            ...nawyTheme.nawy.typography.english.variants.body.md.regular,
          }}
        >
          Share Via Whatsapp
        </Typography>
      </Box>
    </>
  );
};

export default ShareLeadWhatsapp;
